module.exports = __webpack_public_path__ + "static/media/joinourteam.dcc1b293.jpg";